import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { VerificationPendingBanner } from "@/components/VerificationPendingBanner";
import DemoSessionBanner from "@/components/DemoSessionBanner";
import EarlyAccessCommsNoticeModal from "@/components/EarlyAccessCommsNoticeModal";
import EarlyAccessCommunityAgreementModal from "@/components/EarlyAccessCommunityAgreementModal";

export function SiteShell({ children, showFooter = true }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <DemoSessionBanner />
      <VerificationPendingBanner />
      <main className="flex-1">{children}</main>
      {showFooter && <Footer />}
      <EarlyAccessCommsNoticeModal />
      <EarlyAccessCommunityAgreementModal />
    </div>
  );
}
